import { render, staticRenderFns } from "./DexHeaderUserItemExpandable.vue?vue&type=template&id=161efb66&scoped=true&"
import script from "./DexHeaderUserItemExpandable.vue?vue&type=script&lang=js&"
export * from "./DexHeaderUserItemExpandable.vue?vue&type=script&lang=js&"
import style0 from "./DexHeaderUserItemExpandable.vue?vue&type=style&index=0&id=161efb66&prod&scoped=true&lang=css&"
import style1 from "./DexHeaderUserItemExpandable.vue?vue&type=style&index=1&id=161efb66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161efb66",
  null
  
)

export default component.exports